import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { BrandConfigProvider } from './utils/useBrandConfig.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrandConfigProvider>
      <App />
    </BrandConfigProvider>
  </StrictMode>,
)
